import { useEffect, useRef } from "react";
import { PaperPlane } from "@/components/PaperPlane";

export const InkDivider = ({ withPlane = true }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const path = el.querySelector(".ink-path");
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting && path) { path.classList.add("drawn"); obs.unobserve(el); }
      }),
      { threshold: 0.4 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref} className="relative z-10 bg-ink-900 flex items-center justify-center py-2" aria-hidden>
      <div className="relative w-full max-w-3xl flex items-center justify-center px-6">
        <svg viewBox="0 0 600 24" className="w-full h-6" fill="none" preserveAspectRatio="none">
          <path className="ink-path" d="M2 14 C 120 4, 220 20, 300 12 S 480 4, 598 12" stroke="#C9923A" strokeWidth="1.4" strokeLinecap="round" opacity="0.55" />
        </svg>
        {withPlane && (
          <span className="absolute left-1/2 -translate-x-1/2 bg-ink-900 px-4">
            <PaperPlane className="w-5 h-5 -rotate-12 opacity-80" />
          </span>
        )}
      </div>
    </div>
  );
};

export default InkDivider;
